(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-contact"] && !Shopify.designMode) return;
  try {
    
  class BBContactTabs {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      // Handle inline "switch to message" links
      root.querySelectorAll('[data-bb-contact-switch-to]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-bb-contact-switch-to');
          const idx = this.tabs.findIndex((t) => t.id === `bb-tab-${target}`);
          if (idx >= 0) this.activate(idx);
        });
      });
    }
    activate(i) {
      this.tabs.forEach((t, j) => {
        const active = i === j;
        t.setAttribute('aria-selected', String(active));
        t.setAttribute('tabindex', active ? '0' : '-1');
        t.classList.toggle('bb-contact__tab--active', active);
      });
      this.panels.forEach((p, j) => {
        p.classList.toggle('bb-contact__panel--active', i === j);
      });
      this.tabs[i].focus();
    }
    onKey(e, i) {
      const max = this.tabs.length - 1;
      let next = i;
      if (e.key === 'ArrowRight') next = i === max ? 0 : i + 1;
      else if (e.key === 'ArrowLeft') next = i === 0 ? max : i - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = max;
      else return;
      e.preventDefault();
      this.activate(next);
    }
  }

  document.querySelectorAll('.bb-contact').forEach((el) => new BBContactTabs(el));

  // If URL has a hash auto-select — e.g., /pages/contact-us#message
  const hash = window.location.hash.replace('#', '');
  if (hash === 'message' || hash === 'details' || hash === 'faq') {
    const tab = document.getElementById(`bb-tab-${hash}`);
    if (tab) tab.click();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
